import { Box, Divider, List, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/if"
import { LegislationListItem } from "./legislation-list-item"

export function LegislationList({ legislation }) {
    return (
        <If truthy={legislation?.length}>
            <>
                <Divider />
                <Box>
                    <Typography variant="overline" color="text.secondary" display="block" gutterBottom>
                        Referenced Legislation
                    </Typography>
                    <List dense disablePadding>
                        <Repeat list={legislation} item={<LegislationListItem />} keyFn={keyById} />
                    </List>
                </Box>
            </>
        </If>
    )

    function keyById(item) {
        return item.id
    }
}
